import {apiAddPaymentMethodToken, PaymentMethod, type PaymentMethodToken} from "../../../../client/state/PaymentMethodStore.js";
import type {PaymentProcessor} from "../../../../client/state/PaymentProcessorStore";
import type {RecurringPaymentStoreObject} from "../../../../client/state/RecurringPaymentStoreObject";
import type {ApiRequestError} from "../../../../client/connection/BlinkApiClient";
import type {PaymentProcessorType} from "../../../../client/state/PaymentProcessorStore";
import {Messages} from "../../../Messages.js";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService.js";
import {Router} from "../../../../stem-core/ui/Router.jsx";
import {PAYMENT_DETAILS_PANEL_URL} from "../../PanelConstants.js";
import {BaseFlowStep} from "./BaseFlowStep.jsx";


export class PaymentMethodFlowStep extends BaseFlowStep {
    declare selectedValue: PaymentMethod;
    continueLabel = Messages.finalizePayment;
    scope = PaymentMethod.Scope.PUBLIC;
    cardHolderName = ""; // The IDE seems to fail to interpret this as being used, but it actually is.
    showSaveCardCheckbox = true; // If you want to allow an iframe option to override this, track where this variable is used
    // Passed down to ChooseCardComponent as its `recurringPayment`
    entry: RecurringPaymentStoreObject | null = null;
    savePaymentMethod = true;
    retryPayment: (() => void) | null = null;
    paymentError: ApiRequestError | null = null;
    altPayData: {provider: PaymentProcessorType; orderId: string} | null = null; // AmazonPay or PayPal
    // A token that still needs to be added, as StripeCardInput leaves it
    unprocessedNewToken: {token: PaymentMethodToken; scope: string; paymentProcessor: PaymentProcessor} | null = null;

    haveOptionsAvailable() {
        return this.selectedValue || iFrameUserDataService.getExtraPaymentMethodCount();
    }

    getDefaultFields() {
        this.selectedValue = PaymentMethod.getDefault();
    }

    getFieldsToReset() {
        const obj = super.getFieldsToReset();
        if (this.selectedValue) {
            delete obj.cardHolderName;
        }
        delete obj.unprocessedNewToken;
        return obj;
    }

    showPanel() {
        Router.changeURL(PAYMENT_DETAILS_PANEL_URL);
    }

    async getPayload() {
        return {
            preferredPaymentMethodId: this.selectedValue?.id, // TODO @cleanup rename to paymentMethodId
        }
    }

    async sendUnprocessedNewToken() {
        const request = this.unprocessedNewToken;
        if (request == null) {
            throw Error("No existing token to send");
        }
        this.unprocessedNewToken = null;
        const {token, scope, paymentProcessor} = request;
        this.selectedValue = await apiAddPaymentMethodToken(token, scope, paymentProcessor);
        return this.selectedValue;
    }

    maskPayload(payload: Record<string, any>) {
        return {...payload};
    }

    getPaymentErrorMessage() {
        return this.paymentError?.message || "";
    }

    setAltPayOrderId(provider: PaymentProcessorType | null, orderId?: string) {
        // If provider is null, clear the field
        const altPayData = provider && {
            provider,
            orderId,
        }
        this.update({altPayData});
    }
}
